// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { api } from './index'
import { SERVICE_ID } from '../constants'

const endpoint = process.env.REACT_APP_AUTH_ENDPOINT

/**
 * Get users and roles on spec service
 * @param {Object} params
 * @param {number} params.page
 * @param {number} params.page_size
 * @param {string} [params.name]
 */
export function getUsers (params) {
  params.service_id = SERVICE_ID
  return api.get('/worldcam/external/services/users', {
    params,
    baseURL: endpoint
  })
}

/**
 * @param {number} userId
 */
export function deleteUser (userId) {
  return api.delete('/worldcam/external/services/users', {
    params: {
      user_id: userId,
      service_id: SERVICE_ID
    },
    baseURL: endpoint
  })
}

/**
 * Add service user
 * @param {Object} params
 * @param {string} params.email - google email
 * @param {number[]} [params.role_ids]
 * @param {string} [params.extra_user_info]
 */
export function addUser (params) {
  params.service_id = SERVICE_ID
  return api.post('/worldcam/external/services/users_google', params, {
    baseURL: endpoint
  })
}

/**
 * Update roles and extra info
 * @param {Object} params
 * @param {number} params.user_id
 * @param {number[]} params.role_ids
 * @param {string} params.extra_user_info
 */
export function modifyUser (params) {
  params.service_id = SERVICE_ID
  return api.put('/worldcam/external/services/users', params, {
    baseURL: endpoint
  })
}

export function getRoles () {
  return api.get('/worldcam/external/roles', {
    params: {
      service_id: SERVICE_ID
    },
    baseURL: endpoint
  })
}
